<template>
    <div style="background-color: transparent; transition-property: opacity; transition-duration: 400ms;">
        <div class="toast-box">
            {{ toastText }}
        </div>    
    </div>
</template>

<script type="text/javascript">
export default {
    props: {
        toastText: {
            type: String,
            default: null
        }
    },

    data: function() {
        return {

        };
    }
};
</script>

<style type="text/css" scoped>
    .toast-box {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9999;
        font-size: 1rem;
        padding: 32px 0;
        text-align: center;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.8);
    }
</style>